// extracted by mini-css-extract-plugin
module.exports = {"section":"transparencia_section__Y24Yk","content":"transparencia_content__OPhs3"};